import { BaseModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'

export class VacancyIntegrationModel extends BaseModel {
  id: number = 0
  name: string = ''
  isEnabled: boolean = false
  status: string = ''
  createdAt: string = ''
  updatedAt: string = ''

  constructor(data: unknown) {
    super()

    if (isUnknownObject(data)) {
      fillOwnProperties(this, {
        id: data.id,
        name: data.name,
        status: data.status,
        createdAt: data.created_at,
        updatedAt: data.updated_at
      })

      if (typeof data.is_enabled === 'boolean') {
        this.isEnabled = data.is_enabled
      } else if (typeof data.is_enabled === 'number') {
        this.isEnabled = Boolean(data.is_enabled)
      }
    }
  }
}
